module.exports = __webpack_public_path__ + "img/en.e78126ab.png";